export const brighterScoreMockData = {
    heading: "Your Brighter Score",
    note: "Your Brighter score is based on data you provide as well as other sources including state licensing boards, patients, and carriers. Please verify and update the information below to ensure the accuracy of your score.",
    noteText: "It may take up to 24 hours for your score to reflect any changes.",
    brighterScoreText: "Brighter Score",
    name: "Dr. Frederick John",
    address: "4530 S Carson St, Carson City, NV",
    professionalHistoryText: "Professional History",
    patientExperienceText: "Patient Experience",
    affordabilityText: "Affordability",
    scoreTableHeading: "Understanding your overall Brighter Score",
    scoreTableText: "Consult the table below to see how your overall score compares with other providers in your area.",
    scoreTableGrade1: "Excellent",
    scoreTableGradeNote1: "Your score is among the top providers in your area",
    scoreTableGrade2: "Very Good",
    scoreTableGradeNote2: "Your score is better than most providers",
    scoreTableGrade3: "Fair",
    scoreTableGradeNote3: "Your score is average among providers",
    scoreTableGrade4: "Below Average",
    scoreTableGradeNote4: "Your score falls below most providers",
    scoreTableGrade5: "Needs Improvement",
    scoreTableGradeNote5: " One or more of your score components needs significant improvement",
    brighterScoreComponentHeading: "Brighter Score Components",
    professionalHistoryNote: "This score is based on years of experience and the status of your state dental license. Additional formal education, certification by a specialty board, or recognition by a continuing education organization also contribute. Please verify and update your information to make sure your score is accurate.",
    yearsOfExperienceText: "years of experience",
    noLicenseText: "No License Board Actions",
    hasLicenseText: "License Board Action",
    addEducationText: "Add education and training",
    addCertificationsText: "Add certifications",
    reviewNote: "Review & add professional history information on your",
    patientExperience: "Patient Experience:",
    patientExperienceNote: "Using claims from our carrier clients and appointments booked through Brighter Schedule, Brighter surveys verified patients to collect reviews and calculates a weighted score based on the total number of reviews. Office technologies and amenities that improve patient experience also contribute to your score.",
    reviewQuestion1: "How many reviews do you have?",
    patientExperienceBrighterText: "Brighter weights your score based on the number of reviews. The more reviews you have, the more reliable the data.",
    totalReviewText: "Total Reviews",
    patientExperienceScoreNote: "Your Patient Experience score will be N/A until you have at least one review. Until then, the average score across all providers will be used to calculate your overall score and improve your ranking.",
    barLeftLabel1: "Great",
    barLeftLabel2: "Good",
    barLeftLabel3: "Average",
    barLeftLabel4: "Need More",
    barRightLabel1: "25+ Reviews",
    barRightLabel2: "16-24 Reviews",
    barRightLabel3: "6-15 Reviews",
    barRightLabel4: "0-5 Reviews",
    brighterRecommendationHeading: "Brighter Verified Patient Reviews",
    brighterRecommendationText: "Brighter collects reviews from patients based on claims you submit to our carrier clients and appointments booked with Brighter Schedule.",
    recommendationRateText: "Recommendation Rate",
    brighterRecommendations: "Brighter recommendations",
    advancedTechnologiesAmenitiesText: "Advanced Technologies & Amenities",
    affordabilityContentText: "This score measures the impact of your fees to a patient's out-of-pocket costs. Brighter compares your contracted fees for common procedures against fees submitted by providers in your area with the same specialty. Your score is calculated based on your most frequently used fee schedule for this location. Your score for other fee schedules may vary.",
    affordabilityContentNote: "Studies have shown that patients value in-office technologies and amenities, so Brighter incorporates this into the Patient Experience score.",
    contractedFeesText: "Your Cigna contracted fees vs. other General Dentists in your area",
    contactText: "Contact Cigna at 1.800.244.6224 for more details about your fee schedule.",
    footerNote: "Brighter is committed to helping you understand and improve your Brighter Score. If any of your data is out-of-date or inaccurate, or you disagree with Brighter's assessment, please",


}

export const dentistSpecialityCode = {
    "GD": "General Dentists",
    "OR": "Orthodontists",
    "OS": "Oral Surgeons",
    "PE": "Pediatric Dentists",
    "EN": "Endodontists",
    "PO": "Periodontists",
    "PR": "Prosthodontists",
    "HY": "Dental Hygienist"
}

export const brighterScoreApiData = {
    "accessPointDisplayId": "BTQHCHVF82888126",
    "brighterScores": {
        "feeScheduleDisplayId": "WEMPFMSS57262308",
        "networkName": "Cigna",
        "carrier": "Cigna",
        "carrierPhone": "1.800.244.6224",
        "yearsOfExperience": "15",
        "specialtyCode": "PE",
        "affordabilityScore": "7.6",
        "professionalHistoryScore": "10",
        "patientExperienceScore": "9.9",
        "overallScore": "9",
        "cleanLicense": "true",
        "brighterSatisfaction": "1.00",
        "brighterRecommendCount": "29",
        "brighterNotRecommendCount": "0",
        "brighterTotalCount": "29",
        "totalReviewCount": "29",
        "technologies": [
            {
                "name": "Digital X-Rays"
            },
            {
                "name": "Intra-Oral Camera"
            },
            {
                "name": "Sedation Dentistry"
            }
        ],
        "amenities": [
            {
                "name": "Children's Area/Toys"
            },
            {
                "name": "Enclosed Operatory"
            },
            {
                "name": "Handicap Accessible"
            },
            {
                "name": "Television/Movies"
            }
        ],
        "certifications": {
            "name": "American Board of Pediatric Dentistry - Pediatric Dentistry"
        },
        "schools": [
            {
                "name": "University of Nevada, Las Vegas"
            },
            {
                "name": "Weber State Univeristy"
            }
        ]
    }
}